/* eslint-disable react-hooks/exhaustive-deps */
import { Edit } from "@mui/icons-material";
import { Alert, IconButton, Paper } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { PageTitle } from "../../../../shared/ui/common/index.js";
import Exports from "../../../../shared/ui/common/export.jsx";
import CustomeLayout from "../../../../shared/ui/customeTable.jsx";
import DataFetcher from "../../../../shared/api/index.js";
import Filters from "../../../../shared/ui/filters/index.jsx";
import { EDIT_CONVERSTAION_ACTIVE, EXPORT_CONVERSTAION, GET_ALL_CONVERSTAION } from "../../../../shared/api/endpoints.js";
import ConversatoinModal from "./modal.jsx";
import { conversationTableResponse } from "../../api/conversation-table";
import { createConversationRecordsSource } from "../../api/conversation-records";

const Conversation = () => {
  const { userPermissions } = useSelector((state) => state.relationals);
  const [openCreate, setOpenCreate] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [editingData, setEditingData] = useState({});
  const [page, setPage] = useState(1);
  const [filter, setFilter] = useState([]);
  const [sort, setSort] = useState({});
  const [search, setsearch] = useState("");
  const [sumbitSearch, setSumbitSearch] = useState("");
  const [limit, setLimit] = useState(50);
  const [allRows, setAllRows] = useState([]);
  const [selected, setSelected] = useState([]);
  const [allFeilds, setAllFeilds] = useState([]);
  const { token } = useSelector((state) => state.user);
  const { id } = useParams();
  const [refreshData, setRefresh] = useState(0);
  const source = useMemo(() => createConversationRecordsSource(token, Number(id)), [token, id, refreshData]);
  const filterApplied = useMemo(() => [...filter.filter((item) => item.name !== "chatId"),
    { name: "chatId", value: id, type: "eq" }], [filter, id]);
  const { hasMore, loading, errors, allData, CurrentPage, metaData, header, setting } =
    DataFetcher(
      limit,
      page,
      sort,
      GET_ALL_CONVERSTAION,
      filterApplied,
      true,
      refreshData,
      sumbitSearch, 1, false, conversationTableResponse, source.requestPage
    );
  useEffect(() => {
    setAllRows(allData);
  }, [allData]);

  return (
    <>
      <PageTitle
        title="پیام ها"
        broadCrumb={[
          {
            title: "چت",
            path: "/chat",
          },
        ]}
      />
      <div className="md:mx-3 mx-1">
        {errors && <Alert severity="error">دریافت تاریخچه انجام نشد؛ برای تلاش مجدد جدول را به‌روز کنید.</Alert>}
        <p role="status" className="mb-3 text-sm">تاریخچه همین گفتگو؛ تعداد، جستجو و خروجی فقط از پیام‌های همین گفتگو محاسبه می‌شود.</p>
        <Paper
          sx={{ border: "1px solid #dbdfea", mb: 1, padding: "15px 16px" }}
          elevation={0}
        >
          <div className="flex md:gap-4 gap-1 flex-wrap justify-between">
            <Filters
              limit={limit}
              setLimit={setLimit}
              headers={header}
              setFilter={setFilter}
              filter={filter}
              setPage={setPage}
              loading={loading}
            />
            <div className="flex justify-end flex-wrap gap-4 items-center">
   
                <Exports
                  requestExport={source.requestExport}
                  sumbitSearch={sumbitSearch}
                  filter={filter}
                  header={header}
                  data={allData}
                  selectedData={selected}
                  title=" پیام ها"
                  api={EXPORT_CONVERSTAION}
                />
      

              {/*       <Button onClick={() => setOpenCreate(true)} variant="contained">
                <AddIcon />
                افزودن پیام ها جدید
              </Button> */}
            </div>
          </div>
        </Paper>
        <CustomeLayout
          limit={limit}
          setLimit={setLimit}
          setAllRows={setAllRows}
          editApi={EDIT_CONVERSTAION_ACTIVE}
          title="پیام ها"
          headers={header}
          setSearch={setsearch}
          search={search}
          page={page}
          total_pages={metaData?.total_pages}
          setApplySearch={(e) => {
            setPage(1);
            setSumbitSearch(e);
            /* setFilter({ ...filter, search: { value: e, type: "lk" } }); */
          }}
          rows={allRows || []}
          hasMore={hasMore}
          loading={loading}
          setPage={setPage}
          setting={setting}
          CurrentPage={CurrentPage}
          actions={[
            {
              title: "ویرایش",
              handler: (
                <>
                  <IconButton
                    onClick={() => {
                      setOpenEdit(true);
                    }}
                  >
                    <Edit sx={{ color: "#ff2000" }} />
                  </IconButton>
                </>
              ),
            },
          ]}
          length={metaData?.total}
          name={"دسته بندی "}
          maxHeight={{ lg: "69.5vh", md: "68vh", xl: "74vh" }}
          setSort={(e) => {
            setPage(1);
            setSort({ ...sort, ...e });
          }}
          currentRow={(data) => {
            setEditingData(data);
          }}
          setRefresh={setRefresh}
          setSelected={setSelected}
          selected={selected}
        />
      </div>
      <ConversatoinModal
        open={openEdit || openCreate}
        forEdit={openEdit}
        data={editingData}
        setAllRows={setAllRows}
        allRows={allRows}
        allFeilds={allFeilds}
        close={() => {
          setOpenCreate(false);
          setOpenEdit(false);
          setEditingData({});
        }}
      />
    </>
  );
};

export default Conversation;
